import React from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import styles from "./SelectField.module.css";
import { FormHelperText } from "@mui/material";

function SelectField(props) {
  // const [age, setAge] = React.useState('');
  // const handleChanges = (event) => {
  //   setAge(event.target.value);
  // };

  // const options = [
  //   {
  //     label: "Twenty",
  //     value: "Twenty",
  //   },

  //   {
  //     label: "Twentydd",
  //     value: "Twentyd",
  //   },

  // ]

  //   < SelectField
  // label = "Month"
  // options = { options }
  // handleChange = { handleChanges }
  //   />

  const { label, validation, options, selectedOption, handleChange } = props;

  return (
    <div className={styles.TextField}>
      <div className={styles.FieldLabelContainer}>
        <div className={styles.FieldLabel}>
          <span>{label}</span>
          {validation && <span style={{ color: "#d32f2f" }}>*</span>}
        </div>
        <span className={styles.FieldLabelErrorText}>
          {props.error &&
            props.FieldErrorLabel &&
            (props.FieldLabelHelperText
              ? props.FieldLabelHelperText
              : "Required")}
        </span>
      </div>
      <Select
        className={styles.selectField}
        labelId="customized-select-label"
        id="customized-select"
        value={selectedOption}
        onChange={handleChange}
        error={props.error}
        //set a default value
        defaultValue={props.defaultValue}
        disabled={props.disabled}
      >
        {/* <MenuItem value="">
          <em>None</em>
        </MenuItem> */}
        {options?.map((item, i) => (
          <MenuItem
            key={i}
            value={item.value}
            className={styles.SelectOptionItem}
          >
            {item.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText sx={{ color: "#d32f2f" }}>
        {props.helperText}
      </FormHelperText>
    </div>
  );
}

export default SelectField;
